import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useUserRoleAllowed } from '@core/hooks';
import { XUserInteraction } from '@core/utils';
import notificationSound from '@modules/raccoon/src/assets/beep.mp3';
import {
  NEW_NOTIFICATION,
  SET_CONNECTION,
  SET_COUNT_OF_UNREAD_MESSAGES
} from '@modules/raccoon/src/redux/types';
import useRaporty from './hooks/useRaporty';

export const createWithRaccoonWrapper = (pimOnly) => (WrappedComponent) => (
  props
) => {
  const prevMsgsUnread = useRef(0);
  const [connectionIsSet, setConnectionIsSet] = useState(false);

  const connection = useSelector((state) => state.signalRTyp.connection);

  const dispatch = useDispatch();

  useRaporty();

  const setUnreadMsgs = (msgs) => {
    let msgsUnRead = 0;

    msgs.forEach(({ iloscWatkow }) => {
      msgsUnRead += iloscWatkow;
    });

    if (prevMsgsUnread.current < msgsUnRead) {
      const audio = new Audio(notificationSound);
      audio.play();
    }

    prevMsgsUnread.current = msgsUnRead;

    dispatch({
      type: SET_COUNT_OF_UNREAD_MESSAGES,
      payload: msgsUnRead
    });
  };

  const allowMsgsConnection = useUserRoleAllowed([1, 2, 32]);

  useEffect(() => {
    if (connection && !connectionIsSet && allowMsgsConnection && !pimOnly) {
      connection
        .start()
        .then(() => {
          connection.on('Connect', setUnreadMsgs);
          connection.on('NewMessage', setUnreadMsgs);
          connection.on('Message', (msg) => {
            dispatch({ type: NEW_NOTIFICATION, payload: msg });
          });
        })
        .catch(XUserInteraction.notifyError);
    }

    return () => {
      dispatch({ type: SET_CONNECTION, payload: null });
    };
  }, [connection, connectionIsSet, setConnectionIsSet, allowMsgsConnection]);

  return <WrappedComponent {...props} />;
};
